// extracted by mini-css-extract-plugin
export default {"media-section":"media-section_media-section__qiT9K","image":"media-section_image__0CXtJ"};